import React, { useRef, useEffect, useState } from 'react'
import { useAuth } from '../../../../Contexts/AuthContext'
import { getAuth } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'
import app from '../../../../firebase'

const SignInWithGoogleButton = () => {
  const { loginWithGoogle } = useAuth()
  const navigate = useNavigate()
  const buttonRef = useRef(null)
  const overlayRef = useRef(null)

  const handleClick = async () => {
    try {
      await loginWithGoogle()
    } catch (error) {
      await getAuth(app).currentUser?.delete()
      navigate('/login')
    }
  }

  useEffect(() => {
    const googleScript = document.getElementById('google-map-script')

    googleScript.addEventListener('load', () => {
      // Patiently waiting to do the thing
      setupGoogle()
    })

    setupGoogle()
  }, [window.google])

  function setupGoogle() {
    /* global google */
    if (window.google) {
      google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: () => {},
      })

      google.accounts.id.renderButton(buttonRef.current, {
        // type: "standard",
        theme: 'filled_black',
        // size: "small",
        text: 'continue_with',
        shape: 'pill',
      })

      // google.accounts.id.prompt();
    }
  }

  return (
    <>
      <div className="orGoogleText">or</div>

      <div
        style={{ position: 'relative', display: 'inline-block' }}
        ref={overlayRef}
        onClick={handleClick}
      >
        <div ref={buttonRef}></div>

        <button
          style={{
            position: 'absolute',
            inset: 0,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            zIndex: 2,
            pointerEvents: 'auto',
          }}
          aria-label="Continue with Google"
        />
      </div>
    </>
  )
}

export default SignInWithGoogleButton
